import { InjectionToken } from '@angular/core';
import { CreditCardCongif } from '../interfaces/credit-card-config.interface';

export const CREDIT_CARD_CONFIG = new InjectionToken<CreditCardCongif>('CREDIT_CARD_CONFIG');